// Cookie consent from CookieYes, which Google Tag Manager loads (the CookieYes CMP tag in
// GTM-5VZT9RL2). Analytics the app loads itself (PostHog) wait for the visitor
// to accept the analytics category and stop if they withdraw it. Without CookieYes (local
// builds, a blocked script) there is no consent, so they never start. GA4 handles consent
// itself through Google consent mode in GTM, and so does Microsoft Clarity, which is a GTM tag.
const listeners = [];
let analyticsAllowed = false;
let started = false;

function cookieYesAllowsAnalytics() {
  try {
    const consent = typeof window.getCkyConsent === 'function' && window.getCkyConsent();
    return Boolean(consent && consent.categories && consent.categories.analytics);
  } catch (e) {
    return false;
  }
}

function update(allowed) {
  if (allowed === analyticsAllowed) return;
  analyticsAllowed = allowed;
  listeners.forEach(listener => listener(allowed));
}

const Consent = {
  init: () => {
    if (started || typeof document === 'undefined') return;
    started = true;

    // CookieYes fires this once its banner has loaded, with the choice a returning visitor made
    document.addEventListener('cookieyes_banner_load', () => update(cookieYesAllowsAnalytics()));
    document.addEventListener('cookieyes_consent_update', (event) => {
      const accepted = (event.detail && event.detail.accepted) || [];
      update(accepted.indexOf('analytics') !== -1);
    });

    // CookieYes loads through GTM, possibly before or after this runs, so also look for it
    // for a while in case its load event has already gone by
    update(cookieYesAllowsAnalytics());
    let checks = 0;
    const timer = setInterval(() => {
      checks += 1;
      if (typeof window.getCkyConsent === 'function') update(cookieYesAllowsAnalytics());
      if (typeof window.getCkyConsent === 'function' || checks >= 20) clearInterval(timer);
    }, 500);
  },

  // Calls listener(true) once analytics are allowed (straight away if they already are) and
  // listener(false) if the visitor later withdraws consent
  onAnalyticsChange: (listener) => {
    listeners.push(listener);
    if (analyticsAllowed) listener(true);
  }
};

export default Consent;
